import { cancellationConfirmationModalOpenAtom } from '@/features/settings/billing/billingAtoms';
import { useAtomValue } from 'jotai';
import dynamic from 'next/dynamic';

const CancellationConfirmationModalImplementation = dynamic(
  () =>
    import('./cancellation-confirmation-modal-implementation').then(
      (mod) => mod.CancellationConfirmationModalImplementation
    ),
  { ssr: false, loading: () => null }
);

/** Lazy gate for paid cancel flow (intent → reason). */
export function CancellationConfirmationModal() {
  const isOpen = useAtomValue(cancellationConfirmationModalOpenAtom);

  if (!isOpen) {
    return null;
  }

  return <CancellationConfirmationModalImplementation />;
}
